const ROOT_SELECTOR = '#wla-announcement-bar-root';
const ENDPOINT = '/api/announcement-bar';

const isSafeUrl = (url) => {
  try {
    const parsed = new URL(url, window.location.origin);
    return parsed.protocol === 'https:' || parsed.origin === window.location.origin;
  } catch {
    return false;
  }
};

const createAnnouncementLink = (announcement) => {
  const link = document.createElement('a');
  link.className = 'wla-announcement-bar__link';
  link.href = isSafeUrl(announcement.url) ? announcement.url : '/apple-event-kalender/';
  link.setAttribute('aria-label', announcement.text);

  if (announcement.target === '_blank') {
    link.target = '_blank';
    link.rel = announcement.rel || 'noopener noreferrer';
  }

  const text = document.createElement('span');
  text.className = 'wla-announcement-bar__text';
  text.textContent = announcement.text;

  const cta = document.createElement('span');
  cta.className = 'wla-announcement-bar__cta';
  cta.textContent = announcement.cta || 'Læs mere';

  link.append(text, cta);
  return link;
};

const renderAnnouncement = (root, announcement) => {
  root.innerHTML = '';
  root.append(createAnnouncementLink(announcement));
  root.hidden = false;
  root.dataset.announcementId = announcement.id || 'active';
  document.body.classList.add('wla-announcement-bar-active');
};

export const initAnnouncementBar = () => {
  const root = document.querySelector(ROOT_SELECTOR);

  if (!root) {
    return;
  }

  fetch(ENDPOINT, {
    cache: 'no-store',
    headers: {
      accept: 'application/json'
    }
  })
    .then((response) => (response.ok ? response.json() : null))
    .then((announcement) => {
      if (!announcement || announcement.enabled === false || !announcement.text || !announcement.url) {
        return;
      }

      renderAnnouncement(root, announcement);
    })
    .catch(() => {
      root.hidden = true;
    });
};
